<script setup lang="ts">
import { formatQuantity } from '@/composables/inventory/inventoryTable';
import type { MedicineDiagnosisTotal } from '@/types';

defineProps<{
    /** Consumption per diagnosis and unit over every treatment the Log's filters leave, not just the page on screen. */
    totals: MedicineDiagnosisTotal[];
}>();

function rowKey(total: MedicineDiagnosisTotal): string {
    return `${total.diagnosis ?? ''}|${total.unit_id}`;
}
</script>

<template>
    <div class="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 space-y-2">
        <div class="font-medium">{{ $t('views.health.inventory.diagnosisTotals.heading') }}</div>
        <table class="w-full text-normal">
            <thead>
                <tr class="text-left text-gray-500">
                    <th class="py-1 pr-4 font-medium">{{ $t('views.health.inventory.table.headings.diagnosis') }}</th>
                    <th class="py-1 pr-4 font-medium">{{ $t('views.health.inventory.diagnosisTotals.drugs') }}</th>
                    <th class="py-1 pr-4 text-right font-medium">{{ $t('views.health.inventory.diagnosisTotals.treatments') }}</th>
                    <th class="py-1 text-right font-medium">{{ $t('views.health.inventory.diagnosisTotals.quantity') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="total in totals" :key="rowKey(total)" class="border-t border-gray-200">
                    <td class="py-1 pr-4">{{ total.diagnosis ?? '–' }}</td>
                    <td class="py-1 pr-4 text-gray-600">{{ total.drug_names.join(', ') }}</td>
                    <td class="py-1 pr-4 text-right">{{ $n(total.treatments, 'numeric') }}</td>
                    <td class="py-1 text-right font-semibold whitespace-nowrap">{{ formatQuantity(total.quantity) }} {{ total.unit_name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
